import { render, staticRenderFns } from "./t-history-list.vue?vue&type=template&id=2c4cc654&scoped=true"
import script from "./t-history-list.vue?vue&type=script&lang=js"
export * from "./t-history-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cc654",
  null
  
)

export default component.exports